import { Box, InputLabel, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import { FormDatePicker, FormInput } from '@Components/Form';
import { disabledDatePickerTypingStyles } from '@Components/Form/styles';
import FormatNumberInput from '@Components/FormattedNumberInput';
import { GasEmissionUnit } from '@Router/EsgGreenhouse/Components/GasEmissionMessage';
import { NetZeroLabelStyles } from './styles';

type NetZeroBaseYearProps = {
  isCompletedTh: boolean;
  isCompletedEn: boolean;
};

const NetZeroBaseYear = ({
  isCompletedTh,
  isCompletedEn,
}: NetZeroBaseYearProps) => {
  return (
    <>
      <Typography fontWeight={800} mt={2} sx={{ textDecoration: 'underline' }}>
        ปีฐาน
      </Typography>
      <Flex alignItems={'baseline'} gap={2} mt={1}>
        <InputLabel required sx={{ textAlign: 'end', minWidth: '350px' }}>
          ปีฐาน
        </InputLabel>
        <FormDatePicker
          disabled={isCompletedTh || isCompletedEn}
          name="baseYear.year"
          sx={{ width: '100%', ...disabledDatePickerTypingStyles }}
          views={['year']}
          format="BBBB"
          placeholder="เลือกปีฐาน"
          slotProps={{
            toolbar: { hidden: false },
          }}
          localeText={{ toolbarTitle: 'เลือก ปี' }}
        />
      </Flex>
      <Flex alignItems={'baseline'} gap={2} mt={2}>
        <Box minWidth={'350px'}>
          <NetZeroLabelStyles required>
            <Typography>
              ปริมาณการปล่อยก๊าซเรือนกระจก ณ ปีฐาน
              <br />
              ตันคาร์บอนไดออกไซด์เทียบเท่า, <GasEmissionUnit />
            </Typography>
          </NetZeroLabelStyles>
        </Box>
        <FormInput
          fullWidth
          disabled={isCompletedTh || isCompletedEn}
          name="baseYear.gasEmissionQuantity"
          placeholder="โปรดระบุจำนวน"
          sx={{
            '& input': {
              textAlign: 'right',
            },
          }}
          slotProps={{
            input: {
              inputComponent: FormatNumberInput as React.ComponentType,
              inputProps: {
                allowNegative: false,
              },
            },
          }}
        />
      </Flex>
    </>
  );
};

export default NetZeroBaseYear;
